import React, { useState, useEffect } from 'react'
import { useRequest } from 'ahooks'
import Ul from '../../../baseComponent/ul'
import Dropdown from '../../../baseComponent/dropdown'
// import Icon from '../../icon'
import request from '../../../utils/request'
import { GENDER_VALUE } from '../../enum'
import Tile from '../../../baseComponent/select/tile'
import { SelectDisplay } from '../select'
import './index.less'

const convert = (result) => {
  const all = []
  result.forEach((item) => {
    let parent = null
    parent = { label: item.name, value: item.name, node: 1 }
    let children = null
    if (item.children && item.children.length) {
      children = item.children.map(son => ({
        label: son.name,
        value: son.name,
        parent,
        node: 2
      }))
      parent.children = children
    }
    all.push(parent)
  })
  return all
}
const GENDERS = [{ label: '不限', value: undefined },
  { label: '女装', value: GENDER_VALUE.WOMEN },
  { label: '男装', value: GENDER_VALUE.MEN },
  { label: '男童', value: GENDER_VALUE.BOY },
  { label: '女童', value: GENDER_VALUE.GIRL },
  { label: '童装', value: GENDER_VALUE.CHILD },
  { label: '鞋靴', value: GENDER_VALUE.SHOES }]
export default (props) => {
  const { category, shopStatus, onChange, placeholder, trigger, displayClassName, disabled } = props
  const [visible, setVisible] = useState(false)
  const [gender, setGender] = useState(props.gender)

  useEffect(() => {
    setGender(props.gender)
  }, [props.gender])

  const fetchCategories = () => {
    return new Promise((resolve) => {
      if (!gender) {
        resolve([])
      } else {
        request.sget('/zhikuan/common/list-all-category', { gender, shopStatus }, 'MNListCategory').then(res => {
          if (res) {
            resolve(convert(res.children))
          }
        })
      }
    })
  }
  const { data, run } = useRequest(fetchCategories, {
    debounceWait: 250,
    manual: true
  })

  useEffect(() => {
    run()
  }, [gender, shopStatus])
  const onOk = (_gender, _category, _parent) => {
    setVisible(false)
    onChange && onChange(_gender, _category, _parent)
  }
  return <Dropdown
    overlayStyle={{ zIndex: 1001 }}
    trigger={trigger}
    placement="bottomLeft"
    disabled={disabled}
    overlay={<div className="meinian-select-list-cascade meinian-gender-category-select">
      <div className="left">
        <Ul
          value={gender}
          data={GENDERS}
          onMouseEnter={val => setGender(val)}
          className="left-list"
          onChange={val => onOk(val, undefined)}
        />
      </div>
      <div className="right">
        <Tile
          value={category}
          data={data}
          onChange={(val, item) => onOk(gender, val, item?.parent?.value)}
          allowClear={false}
        />
      </div>
    </div>}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
  >
    <span>{category ? <SelectDisplay.Level
      prefix={`${props.gender}-`}
      showValueAsLabel
      value={category}
      data={data}
      visible={visible}
      className={displayClassName}
      disabled={disabled}
      onClear={() => onOk(undefined, undefined)}
      placeholder={placeholder || '品类'}
    />
      : <SelectDisplay
          value={props.gender}
          data={GENDERS}
          placeholder={placeholder || '品类'}
          visible={visible}
          disabled={disabled}
          className={displayClassName}
          onClear={() => onOk(undefined, undefined)}
      />}</span>
  </Dropdown>
}
